import { Building2, Shield, Stethoscope, User } from 'lucide-react';

type Props = {
  entry: { kind: 'user' | 'role' | 'source'; clinic_id?: string | null };
};

/** A source with a clinic is a building, a discipline-only source a
 *  stethoscope. */
export function EntryIcon({ entry }: Props) {
  const Icon =
    entry.kind === 'role'
      ? Shield
      : entry.kind === 'user'
        ? User
        : entry.clinic_id
          ? Building2
          : Stethoscope;
  return <Icon className='h-4 w-4 shrink-0 text-muted-foreground' />;
}
